import React from 'react';
import { FormattedMessage } from 'react-intl';

import GenericDialog from '../GenericDialog';
import ContentBox from '../layout/ContentBox';
import TrialMetadataDialog from './TrialMetadataDialog';
import ApiClient from '../../loopback/apiClient';
import {
  Institute,
  Survey,
  Trial,
  TrialTagMapping,
} from '../../redux/types';
import { DefaultDataType as ComboboxDataType } from '../layout/ComboBox';

type Props = {
  trial: Trial;
  onClose: () => void;
  isOpen: boolean;
  updateTrial: (trial: ExtendedTrial, trialTags: ComboboxDataType[]|null) => void;
  onDuplicate?: (trial: Trial) => void;
}

type ExtendedTrial = (Trial & {
  survey?: Survey,
  trialTagMapping?: TrialTagMapping[],
});

type State = {
  trials?: ExtendedTrial[];
  locale?: string;
}

class EditTrialDialog extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  componentDidMount(): void {
    this.fetchTrials();
  }

  fetchTrials = async (): Promise<void> => {
    const { trial } = this.props;
    const filterQuery = {
      where: {
        id: trial.id,
      },
      include: ['survey', 'trialTagMapping'],
    };
    const trialWithSurvey = await ApiClient.getTrials<ExtendedTrial>(filterQuery);
    this.setState({ trials: trialWithSurvey });
  };

  render(): JSX.Element {
    const {
      onClose,
      isOpen,
      updateTrial,
      onDuplicate,
    } = this.props;
    const {
      trials: stateTrials,
    } = this.state;
    return (
      <>
        <GenericDialog isOpen={isOpen} onRequestClose={() => onClose()}>
          <ContentBox
            title={<FormattedMessage id="trialmanagement.editTrialButton" />}
          >
            <div>
              {
                stateTrials
                && stateTrials[0]
                  && (
                  <TrialMetadataDialog
                    trial={stateTrials[0]}
                    onSave={updateTrial}
                    onCancel={onClose}
                    onDuplicate={onDuplicate}
                  />
                  )
              }
            </div>
          </ContentBox>
        </GenericDialog>
      </>
    );
  }
}

export default EditTrialDialog;
